<template>
  <div class="app-footer-wrapper">
    <div class="footer-inner-wrapper">
      <div class="footer-up-container">
        <div class="logo-container">
          <Logo />
        </div>
        <div class="address-container">
          <div class="icon-wrapper">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
            >
              <g clip-path="url(#clip0_161_482)">
                <path
                  d="M6.0002 7.13451C4.7882 7.13451 3.8042 6.18051 3.8042 5.00451C3.8042 3.82851 4.7882 2.87451 6.0002 2.87451C7.2122 2.87451 8.1962 3.82851 8.1962 5.00451C8.1962 6.18051 7.2122 7.13451 6.0002 7.13451ZM6.0002 3.62451C5.2202 3.62451 4.5782 4.24851 4.5782 5.00451C4.5782 5.76051 5.2142 6.38451 6.0002 6.38451C6.7862 6.38451 7.4222 5.76051 7.4222 5.00451C7.4222 4.24851 6.7802 3.62451 6.0002 3.62451Z"
                  fill="white"
                />
                <path
                  d="M6.0002 11.9043C5.9222 11.9043 5.8562 11.8863 5.7842 11.8443C5.5862 11.7183 0.960205 8.68226 0.960205 5.01026C0.960205 2.31626 3.22221 0.114258 6.0002 0.114258C8.7782 0.114258 11.0402 2.30426 11.0402 5.01026C11.0402 8.63426 6.4142 11.7183 6.2162 11.8443C6.1562 11.8743 6.0782 11.9043 6.0002 11.9043ZM6.0002 0.858258C3.64821 0.858258 1.73421 2.71226 1.73421 4.99826C1.73421 7.84826 5.1062 10.4223 6.0002 11.0583C6.8942 10.4163 10.2662 7.80626 10.2662 4.99826C10.2662 2.71826 8.3522 0.858258 6.0002 0.858258Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_161_482">
                  <rect
                    width="12"
                    height="12"
                    fill="white"
                    transform="translate(0 0.00634766)"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div class="address-text">
            {{
              `91 Bencoolen Street, #12-03, Sunshine Plaza, Singapore 189652`
            }}
          </div>
        </div>
      </div>
      <div class="footer-down-container">
        <div class="website-registration">
          © 2026 100XT DIGITAL PTE. LTD. All Rights Reserved
        </div>
        <div class="right-community-wrapper">
          <a href="/" class="icon-wrapper">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M1.9903 1.80762C3.5803 1.81262 5.17101 1.8069 6.76101 1.81047C8.14101 3.81262 9.51387 5.82047 10.896 7.8219C12.6289 5.82405 14.3453 3.81047 16.0746 1.80976C16.5439 1.81047 17.0132 1.80762 17.4824 1.81119C15.5039 4.12476 13.5074 6.42262 11.5324 8.73905C13.6824 11.8983 15.8574 15.039 18.0182 18.1912C16.4289 18.1919 14.8403 18.189 13.251 18.1926C11.7832 16.074 10.331 13.9462 8.86958 11.824C7.05244 13.9498 5.21601 16.0598 3.40315 18.189C2.92958 18.1948 2.45673 18.1898 1.98315 18.1912C4.06744 15.7619 6.15601 13.3376 8.24387 10.9126C6.15887 7.87833 4.07101 4.84547 1.9903 1.80762ZM3.90458 2.86119C7.23958 7.6319 10.5696 12.4062 13.9132 17.1719C14.636 17.1698 15.3589 17.1726 16.0817 17.1705C12.7417 12.4026 9.41244 7.62833 6.07244 2.86047C5.34958 2.85905 4.62744 2.85762 3.90458 2.86119Z"
                fill="white"
              />
            </svg>
          </a>
          <a href="/" class="icon-wrapper">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M18.2231 5.88135C18.0356 5.13135 17.4463 4.56885 16.6963 4.35456C15.357 4.00635 9.9999 4.00635 9.9999 4.00635C9.9999 4.00635 4.64275 4.00635 3.30347 4.35456C2.55347 4.54206 1.99097 5.13135 1.77668 5.88135C1.42847 7.22063 1.42847 10.0063 1.42847 10.0063C1.42847 10.0063 1.42847 12.7921 1.77668 14.1313C1.96418 14.8813 2.55347 15.4438 3.30347 15.6581C4.64275 16.0063 9.9999 16.0063 9.9999 16.0063C9.9999 16.0063 15.357 16.0063 16.6963 15.6581C17.4463 15.4706 18.0088 14.8813 18.2231 14.1313C18.5713 12.7921 18.5713 10.0063 18.5713 10.0063C18.5713 10.0063 18.5713 7.22063 18.2231 5.88135ZM8.28561 12.5778V7.43492L12.732 10.0063L8.28561 12.5778Z"
                fill="white"
              />
            </svg>
          </a>
          <a href="/" class="icon-wrapper">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M13.7913 2.63281H7.33682C4.96136 2.63281 3 4.55508 3 6.96962V13.4241C3 15.7996 4.92228 17.7687 7.34463 17.7687H13.7991C16.1746 17.7687 18.1437 15.8465 18.1437 13.4241V6.96962C18.0968 4.55508 16.1746 2.63281 13.7913 2.63281ZM10.5875 14.0336C7.55143 14.0336 5.32653 10.5709 7.68103 7.34766C7.71898 7.29578 7.7649 7.25022 7.81708 7.21268C11.0335 4.90131 14.4789 7.10269 14.4789 10.1422C14.4789 12.2988 12.7364 14.0336 10.5875 14.0336ZM14.5883 7.00872C14.096 7.00872 13.6819 6.59455 13.6819 6.10229C13.6819 5.60999 14.096 5.19587 14.5883 5.19587C15.0806 5.19587 15.4947 5.60999 15.4947 6.10229C15.4947 6.59454 15.0806 7.00872 14.5883 7.00872ZM10.5875 7.64949C9.18878 7.64949 8.09481 8.78253 8.09481 10.1422C8.09481 11.5409 9.22786 12.6348 10.5875 12.6348C11.9862 12.6348 13.0802 11.5018 13.0802 10.1422C13.0802 8.78253 11.9472 7.64949 10.5875 7.64949Z"
                fill="white"
              />
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts"></script>
<style lang="scss" scoped>
.app-footer-wrapper {
  background: #191a1c;
  .footer-inner-wrapper {
    height: 221px;
    max-width: 1280px;
    width: 100%;
    margin: 0 auto;
    box-sizing: border-box;
    @media screen and (max-width: 1280px) {
      padding-left: 30px;
      padding-right: 30px;
    }
    .footer-up-container {
      height: 117px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      padding-top: 30px;
      padding-bottom: 30px;
      .logo-container {
        height: 32px;
        width: 93px;
        overflow: hidden;
        cursor: pointer;
      }
      .address-container {
        margin-top: 24px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 8px;
        .icon-wrapper {
          width: 12px;
          height: 12px;
          flex-shrink: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          overflow: hidden;
        }
        .address-text {
          font-size: 14px;
          font-weight: 400;
          color: #ffffff;
          line-height: 14px;
        }
      }
    }
    .footer-down-container {
      height: 104px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 30px;
      .website-registration {
        height: 14px;
        line-height: 14px;
        font-size: 14px;
        font-weight: 400;
        color: #ffffff;
      }
      .right-community-wrapper {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-auto-flow: column;
        align-items: center;
        gap: 8px;
        .icon-wrapper {
          display: block;
          width: 24px;
          height: 24px;
          flex-shrink: 0;
          cursor: pointer;
          border-radius: 4px;
          background: rgba(199, 206, 214, 0.2);
          display: flex;
          justify-content: center;
          align-items: center;
          &:hover {
            background: rgba(199, 206, 214, 0.5);
          }
        }
      }
    }
  }
}
</style>
